



























































import Vue from 'vue';
import { mapActions } from 'vuex';
import ItemListing from './ItemListing.vue';
import Config from '../../../../configuration';

import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    methods: {
        ...mapActions('bh-market-items', { createNewMarketItem: 'create', patchMarketItem: 'patch' })
    },
    components: {
        ItemListing
    }
})
export default class QuestListsTable extends Vue {
    @Prop({ default() { return null; } })
    item!: any;

    @Prop({ default: 'Token' })
    type!: string;

    @Prop({ default: null })
    routin!: string;

    dialogAdd = false;
    dialogLoading = false;

    createNewMarketItem: any;
    patchMarketItem: any;

    itemSelected = null;

    isAccountLimited = this.item && this.item.count_per_user !== -1 ? 'Limited' : 'Unlimited';
    stockLimit = this.item && this.item.stock_count !== -1 ? 'Limited' : 'Unlimited';

    levelRistricted = this.item && !!this.item.level_limit && this.item.level_limit !== -1;

    form = {
        item_id: this.item ? this.item.item_id : null,
        price: this.item ? this.item.price : null,
        type: this.item ? this.item.type : this.type,
        count_per_user: this.item ? this.item.count_per_user : -1,
        stock_count: this.item ? this.item.stock_count : -1,
        level_limit: this.item ? this.item.level_limit : -1,
    };

    public valueComparison(a: any, b: any) {
        return a === b;
    }

    @Watch('dialogAdd')
    ResetForm(nv: boolean) {
        if(nv && this.item === null) {
            this.form = {
                item_id: this.item ? this.item.item_id : null,
                price: this.item ? this.item.price : null,
                type: this.item ? this.item.type : this.type,
                count_per_user: this.item ? this.item.count_per_user : -1,
                stock_count: this.item ? this.item.stock_count : -1,
                level_limit: this.item ? this.item.level_limit : -1,
            };
            this.itemSelected = null;
        }
    }

    public async submit() {
        this.dialogLoading = true;
        try {
            const formResult = Object.assign({}, this.form);
            
            if(this.item !== null) {
                const patchedItem = Object.keys(formResult).reduce((res: any, key: string) => {
                    const value = (formResult as any)[key];
                    if(value !== null && typeof value !== 'undefined')
                        res[key] = value;
                    return res;
                }, {});
                this.patchMarketItem([this.item.id, patchedItem]);
            } else {
                await this.createNewMarketItem(formResult);
            }
            this.dialogAdd = false;
            this.$emit('success');
        } catch(err) {
            this.$emit('error', err);
        } finally {
            this.dialogLoading = false;
        }
    }

    public onItemSelected(item: any) {
        this.itemSelected = item;
        this.form.item_id = item.id;
    }

    public async toBase64(file: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
}
